// src/pages/InvoicesPage.js
import React, { useState } from "react";
import PageHeader from "../components/ui/PageHeader";
import InvoiceList from "../components/invoices/InvoiceList";
import InvoiceForm from "../components/invoices/InvoiceForm";
import InvoiceDetail from "../components/invoices/InvoiceDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const InvoicesPage = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchParams] = useSearchParams();

  // Preset para el formulario (ej: añadir fracción de proforma)
  const [formPreset, setFormPreset] = useState(null);

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleView = (invoice) => {
    navigate(`/invoices/${invoice.id}`);
  };

  const handleEdit = (invoice) => {
    setEditingInvoice(invoice);
    setFormPreset(null);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingInvoice(null);
    setFormPreset(null);
    setRefreshKey((k) => k + 1);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingInvoice(null);
    setFormPreset(null);
  };

  // Callback que recibe InvoiceList al pulsar "Añadir fracción"
  const handleAddFraction = (preset) => {
    setEditingInvoice(null);
    setFormPreset({
      invoiceType: "proforma",
      isFractioned: true,
      proformaNumber: preset.proformaNumber,
      fraction: preset.fraction,
      baseInvoice: preset.baseInvoice,
    });
    setShowForm(true);
  };

  if (invoiceId) {
    return <InvoiceDetail invoiceId={invoiceId} onEdit={handleEdit} />;
  }

  return (
    <Box>
      <Box
        sx={{
          backgroundColor: "#ffebee",
          border: "2px solid #d32f2f",
          borderRadius: "12px",
          padding: "16px 24px",
          marginBottom: "24px",
          textAlign: "center",
        }}
      >
        <Box
          component="span"
          sx={{
            color: "#d32f2f",
            fontWeight: 800,
            fontSize: { xs: "1.1rem", sm: "1.5rem", md: "1.8rem" },
            letterSpacing: "1px",
            textTransform: "uppercase",
            display: "block",
            lineHeight: 1.3,
          }}
        >
          ⚠️ LA GRAN MAYORIA DE LAS FACTURAS SE CREAN AQUÍ. ES PARA ENVIAR FACTURAS EN PDF A LOS CLIENTES ⚠️
        </Box>
      </Box>
      <PageHeader
        title="Facturación"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingInvoice(null);
              setFormPreset(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              "&:hover": {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: "brightness(1.05)",
              },
            }}
          >
            Nueva Factura
          </Button>
        }
      />
      <InvoiceList
        key={refreshKey}
        onView={handleView}
        onEdit={handleEdit}
        onAddFraction={handleAddFraction}
      />

      <Dialog
        key={editingInvoice?.id || formPreset?.fraction || "new"}
        open={showForm}
        onClose={handleCancel}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <InvoiceForm
            invoice={editingInvoice}
            preset={formPreset}
            onSave={handleSave}
            onCancel={handleCancel}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default InvoicesPage;